import { render } from "./BioTwo.vue?vue&type=template&id=678807ee"
import script from "./BioTwo.vue?vue&type=script&lang=js"
export * from "./BioTwo.vue?vue&type=script&lang=js"

import "./BioTwo.vue?vue&type=style&index=0&id=678807ee&lang=css"
script.render = render

export default script